export const GUARDRAILS_MAX_LENGTH = 500;

export const validateGuardrails = (guardrails = '') => {
	const value = guardrails.trim();
	const characterCount = value.length;
	const isTooLong = characterCount > GUARDRAILS_MAX_LENGTH;

	return {
		isValid: !isTooLong,
		errorMessage: isTooLong
			? `Guardrails cannot exceed ${GUARDRAILS_MAX_LENGTH} characters`
			: undefined,
		value,
		characterCount,
	};
};
